import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import {
  Shield as HipaaIcon,
  CalendarMonth as H2Icon,
  ChevronRight as ChevronRightIcon,
} from '@mui/icons-material';

const PRIMARY = '#0f1f3d';
const NAVY2   = '#1a3460';

const CARDS = [
  {
    key: 'hipaa-cui',
    icon: HipaaIcon,
    color: '#1565c0',
    label: 'H1-2026',
    title: 'HIPAA/CUI — H1-2026',
    subtitle: 'Privacy, security & controlled unclassified information compliance — first half 2026 delivery tracking',
  },
  {
    key: 'h2-2026',
    icon: H2Icon,
    color: '#6a1b9a',
    label: 'H2-2026',
    title: 'Compliance — H2-2026',
    subtitle: 'Operational Compliance and Azure Gov Compliance workstream — second half 2026 delivery tracking',
  },
];

const ComplianceDeliveryLanding = ({ onNavigate }) => (
  <Box sx={{ width: '100%', maxWidth: '100%', bgcolor: '#edf1f7', minHeight: '100%', borderRadius: 2, p: 0 }}>
    {/* Header */}
    <Box sx={{
      background: `linear-gradient(105deg, ${PRIMARY} 0%, ${NAVY2} 100%)`,
      borderRadius: '12px 12px 0 0',
      px: 3, py: 2,
      display: 'flex', alignItems: 'center', gap: 2,
    }}>
      <Box sx={{
        width: 40, height: 40, borderRadius: '10px', flexShrink: 0,
        bgcolor: 'rgba(255,255,255,0.15)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <HipaaIcon sx={{ color: '#fff', fontSize: 22 }} />
      </Box>
      <Box>
        <Typography sx={{ fontWeight: 720, fontSize: 20, letterSpacing: '-0.3px', color: '#fff', lineHeight: 1.2 }}>
          Compliance Delivery
        </Typography>
        <Typography sx={{ fontSize: 13, color: '#cfe0eb', mt: 0.3 }}>
          Select a compliance workstream to view
        </Typography>
      </Box>
    </Box>

    {/* Cards */}
    <Box sx={{ p: 4, display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}>
      <Grid container spacing={2.5} sx={{ maxWidth: 780 }}>
        {CARDS.map(({ key, icon: Icon, color, label, title, subtitle }) => (
          <Grid item xs={12} sm={6} key={key}>
            <Paper
              elevation={0}
              onClick={() => onNavigate(key)}
              role="button"
              tabIndex={0}
              onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && onNavigate(key)}
              sx={{
                p: 2.5, borderRadius: '14px', cursor: 'pointer',
                border: '1.5px solid rgba(0,0,0,0.07)',
                position: 'relative', overflow: 'hidden',
                transition: 'all 0.2s cubic-bezier(0.4,0,0.2,1)',
                '&:hover': {
                  transform: 'translateY(-3px)',
                  boxShadow: `0 12px 32px rgba(0,0,0,0.10), 0 0 0 2px ${color}35`,
                  borderColor: `${color}50`,
                },
                '&:focus-visible': { outline: `3px solid ${color}`, outlineOffset: 2 },
              }}
            >
              {/* Top row: icon + badge */}
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.75 }}>
                <Box sx={{
                  width: 44, height: 44, borderRadius: '12px',
                  bgcolor: `${color}12`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                }}>
                  <Icon sx={{ color, fontSize: 24 }} />
                </Box>
                <Box sx={{
                  display: 'inline-flex', alignItems: 'center', gap: 0.6,
                  px: 1.25, py: 0.35, borderRadius: '20px', bgcolor: `${color}12`,
                }}>
                  <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: color }} />
                  <Typography sx={{ fontSize: 11, fontWeight: 700, color, letterSpacing: '0.2px' }}>
                    {label}
                  </Typography>
                </Box>
              </Box>

              {/* Title */}
              <Typography sx={{ fontWeight: 700, fontSize: 15.5, color: '#0f1f3d', lineHeight: 1.3, mb: 0.75 }}>
                {title}
              </Typography>

              {/* Subtitle */}
              <Typography sx={{ fontSize: 12.5, color: '#6b7685', lineHeight: 1.6, mb: 2 }}>
                {subtitle}
              </Typography>

              {/* CTA */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                <Typography sx={{ fontSize: 12.5, fontWeight: 650, color }}>View workstream</Typography>
                <ChevronRightIcon sx={{ fontSize: 16, color }} />
              </Box>

              {/* Decorative circle */}
              <Box sx={{
                position: 'absolute', bottom: -24, right: -24,
                width: 100, height: 100, borderRadius: '50%',
                bgcolor: `${color}07`, pointerEvents: 'none',
              }} />
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  </Box>
);

export default ComplianceDeliveryLanding;
